import { render, staticRenderFns } from "./BulkQuickActions.vue?vue&type=template&id=1f27bf3f&scoped=true"
import script from "./BulkQuickActions.vue?vue&type=script&lang=js"
export * from "./BulkQuickActions.vue?vue&type=script&lang=js"
import style0 from "./BulkQuickActions.vue?vue&type=style&index=0&id=1f27bf3f&prod&lang=scss"
import style1 from "./BulkQuickActions.vue?vue&type=style&index=1&id=1f27bf3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f27bf3f",
  null
  
)

export default component.exports